import commaNumber from 'comma-number';
import styled, { css } from 'styled-components';

import useColor from '@/hooks/domain/useColor';
import { undefinedException } from '@/utils/util';

import { Flex } from '../../base';
import { MainText } from '../../Typography/NamedTypo';
import Typo from '../../Typography/Typo';

export type LegendProps = {
  name: string;
  value: number;
  color: string;
  selected?: boolean;
  percentage?: number;
  datas?: (string | number)[];
};

const LegendItem = (props: LegendProps) => {
  const color = useColor();
  return (
    <LegendItemStyle j="space-between" g="4px" selected={props.selected}>
      <Flex g="4px" a="center">
        <div
          className="color-chip"
          style={{ backgroundColor: props.color }}
        ></div>
        <MainText ellipsis>{props.name}</MainText>
      </Flex>
      <Flex a="center" g="6px">
        <Typo type="label1" weight="sb" color={color.gray700} className="value">
          {commaNumber(props.value)}
        </Typo>
        {undefinedException(props.percentage) && (
          <MainText>({props.percentage!.toFixed(0)}%)</MainText>
        )}
      </Flex>
    </LegendItemStyle>
  );
};

const LegendItemStyle = styled(Flex)`
  background-color: ${(props) => props.theme.colors.ND02};
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s;
  :hover {
    background-color: ${(props) => props.theme.colors.ND04};
  }
  ${({ selected }) =>
    selected &&
    css`
      background-color: ${(props) => props.theme.colors.primaryAlpha(0.08)};
      :hover {
        background-color: ${(props) => props.theme.colors.primaryAlpha(0.12)};
      }
    `}
  .color-chip {
    width: 16px;
    min-width: 16px;
    height: 16px;
    border-radius: 4px;
  }
  .value {
    padding-left: 20px;
  }
`;

export default LegendItem;
